module.exports = __webpack_public_path__ + "img/btn_right.896d45d4.png";